
export default {
  path: '/home',
  name: 'homePage',
  component: () => import('@/views/App.vue'),
  children: [
    {
      path: 'index',
      component: () => import('@/components/home/Phone.vue'),
      meta: {
        title: '首页'
      }
    },
    {
      path: 'agreement',
      component: () => import('@/components/home/Agreement.vue'),
      meta: {
        title: '推推产品许可使用协议'
      }
    },
    {
      path: 'privacy',
      component: () => import('@/components/home/Privacy.vue'),
      meta: {
        title: '推推隐私政策'
      }
    }
  ]
}
